import { post } from 'aws-amplify/api';
import { getCurrentUser } from 'aws-amplify/auth';

/**
 * Llama a la API REST `portalvinoteca` (proxy a los RESTlets de NetSuite).
 * Encapsula el boilerplate repetido en los módulos CRUD: usuario actual,
 * header JSON, el campo `q` (username en base64) y el parseo de la respuesta.
 *
 * @param {string} path  ruta del RESTlet, p.ej. '/procesaclustertype'
 * @param {object} body  cuerpo de la petición (action + campos); se le agrega `q`
 * @returns {Promise<object>} el JSON ya parseado de la respuesta
 */
export async function callProcesa(path, body) {
  const userDetails = await getCurrentUser();

  const response = await post({
    apiName: 'portalvinoteca',
    path,
    options: {
      headers: { 'Content-Type': 'application/json' },
      body: { ...body, q: window.btoa(userDetails.username) },
    },
  }).response;

  return response.body.json();
}
